export enum SelectableDateTypes {
    Future = "future",
    Past = "past",
    Both = "both",
}
